import { render } from "./ProductNavbar.vue?vue&type=template&id=38bc4829&scoped=true"
import script from "./ProductNavbar.vue?vue&type=script&lang=js"
export * from "./ProductNavbar.vue?vue&type=script&lang=js"

import "./ProductNavbar.vue?vue&type=style&index=0&id=38bc4829&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bc4829"]])

export default __exports__